import { asSeconds } from "../../units/duration.js";
const USD_PER_VOICE_CREDIT = 0.3;
const VOICE_CREDITS_PER_MINUTE = 1;
const VOICE_SILENCE_THRESHOLD_SECONDS = asSeconds(10);
const VOICE_MINIMUM_CREDITS_PER_CALL = 1;
export {
  USD_PER_VOICE_CREDIT,
  VOICE_CREDITS_PER_MINUTE,
  VOICE_MINIMUM_CREDITS_PER_CALL,
  VOICE_SILENCE_THRESHOLD_SECONDS
};
//# sourceMappingURL=voiceCredits.js.map
